<template>
  <v-card color="#eeeeee" class="pt-1">
    <v-card-title class="primary--text pl-3 py-2 flex-wrap">
      <v-btn
        text
        color="primary"
        class="title"
        @click="$emit('openPredictors')"
      >
        <v-icon left dark large class="pr-2">add_circle</v-icon>
        Predictors
      </v-btn>

      <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on: tooltip }">
          <span v-on="{ ...tooltip }" @click="$emit('openPredictors')">
            <v-chip label color="primary" class="white--text title mr-2">
              {{ predictorCount }}
            </v-chip>
            <span class="black--text text-body-1">
              of {{ predictorTotal }}
            </span>
          </span>
        </template>
        <span class="subtitle-1">
          {{ predictorCount }} of {{ predictorTotal }} available predictor
          variable{{ predictorTotal === 1 ? '' : 's' }} selected
        </span>
      </v-tooltip>

      <v-divider vertical class="ml-4 mr-4"></v-divider>

      <v-btn text color="primary" class="title" @click="$emit('openOutcomes')">
        <v-icon left dark large class="pr-2">add_circle</v-icon>
        Outcomes
      </v-btn>

      <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on: tooltip }">
          <span v-on="{ ...tooltip }" @click="$emit('openOutcomes')">
            <v-chip label color="primary" class="white--text title mr-2">
              {{ outcomeCount }}
            </v-chip>
            <span class="black--text text-body-1"> of {{ outcomeTotal }} </span>
          </span>
        </template>
        <span class="subtitle-1">
          {{ outcomeCount }} of {{ outcomeTotal }} available outcome variable{{
            outcomeTotal === 1 ? '' : 's'
          }}
          selected
        </span>
      </v-tooltip>

      <v-spacer />

      <span class="black--text text-body-2 mr-4"> {{ contextLabel }} </span>

      <v-btn
        text
        small
        color="primary"
        :disabled="predictorCount === 0 && outcomeCount === 0"
        @click="$emit('clear')"
      >
        clear
      </v-btn>

      <v-btn text small color="primary" @click="$emit('reset')"> reset </v-btn>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'VariableToolbar',
  props: {
    predictorCount: {
      type: Number,
      required: true,
    },
    predictorTotal: {
      type: Number,
      required: true,
    },
    outcomeCount: {
      type: Number,
      required: true,
    },
    outcomeTotal: {
      type: Number,
      required: true,
    },
    // population / longitudinality summary, shown on the right
    contextLabel: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
/* the count chips act as secondary launchers for their dialog */
.v-card__title span[class*='black--text'] {
  cursor: default;
}
</style>
